<template>
  <div class="diy-topbar__logo">
    <transition name="scale-in">
      <div v-if="showLogo" class="diy-topbar__logo-wrapper">
        <img :src="DIYLogo" alt="diy-logo" class="diy-topbar__logo-image" />
      </div>
    </transition>
  </div>
</template>

<script>
// Components
import DIYLogoImage from 'Images/logo/diy-logo.png'

export default {
  name: 'TheTopbarLogo',

  data() {
    return {
      timeout: null,
      showLogo: false,
    }
  },

  computed: {
    DIYLogo() {
      return DIYLogoImage
    },
  },

  mounted() {
    this.timeout = setTimeout(() => {
      this.showLogo = true
    }, 250)
  },

  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>

<style scoped>
.diy-topbar__logo {
  display: flex;
  align-items: center;
  max-width: 117px;
}

.diy-topbar__logo-image {
  width: 100%;
}
</style>
